import { ClientBase } from "./base.js";
import { RolesClient } from "./roles.js";
/** Staff time clock (/time-clock): punch in and out, own status, supervisor list and correction. */
export class StaffTimeClockClient extends RolesClient {
    clockBase(slug) {
        return `${this.siteBase(slug)}/time-clock`;
    }
    /** The signed-in person clocks in or out. 409 when already in (or not in). */
    async punchTimeClock(slug, action) {
        return this.request("POST", `${this.clockBase(slug)}/punch`, { action }, true);
    }
    /** Is the signed-in person clocked in? Drives the clock-in gate. */
    async getTimeClockStatus(slug) {
        return this.request("GET", `${this.clockBase(slug)}/me`, undefined, true);
    }
    /** Supervisors see everyone; other staff only their own shifts. */
    async listTimeClockEntries(slug, params = {}) {
        const res = await this.request("GET", `${this.clockBase(slug)}/entries${ClientBase.query({ from: params.from, to: params.to, userId: params.userId })}`, undefined, true);
        return res.entries;
    }
    /** Supervisors only: fix a shift with a reason; the original times stay in `edits`. */
    async patchTimeClockEntry(slug, id, input) {
        return this.request("PATCH", `${this.clockBase(slug)}/entries/${encodeURIComponent(id)}`, input, true);
    }
}
//# sourceMappingURL=staffTimeClock.js.map